import React from 'react';
import { useTranslation } from 'react-i18next';

import './index.less';

import IbIcon from '../../common/IbIcon';
import IbTypography from '../../common/IbTypography';
import { AgentMessageEventHandoffData } from '../../../../gamma-api';

const MAIN_CLASS_NAME = 'handoff-event';
const SELECTED_CLASS_NAME = `${MAIN_CLASS_NAME}_selected`;
const DEFAULT_SIZE_CLASS_NAME = `${MAIN_CLASS_NAME}_size-default`;
const SMALL_SIZE_CLASS_NAME = `${MAIN_CLASS_NAME}_size-small`;
const ICON_CONTAINER_CLASS_NAME = `${MAIN_CLASS_NAME}__icon-container`;
const STATUS_CLASS_NAME = `${MAIN_CLASS_NAME}__status`;

export enum HandoffEventSize {
  DEFAULT = 'default',
  SMALL = 'small',
}

const iconSizeMap = {
  [HandoffEventSize.DEFAULT]: 20,
  [HandoffEventSize.SMALL]: 16,
};

const paragraphTypeMap = {
  [HandoffEventSize.DEFAULT]: 'normal' as const,
  [HandoffEventSize.SMALL]: 'secondary' as const,
};

export interface IHandoffEventProps {
  handoffData: AgentMessageEventHandoffData;
  isSelected?: boolean;
  size?: HandoffEventSize;
  onSelect?: () => void;
}

const HandoffEvent: React.FC<IHandoffEventProps> = ({
  handoffData,
  isSelected = false,
  size = HandoffEventSize.DEFAULT,
  onSelect,
}) => {
  const { t } = useTranslation();

  const classes = [MAIN_CLASS_NAME];
  if (isSelected) {
    classes.push(SELECTED_CLASS_NAME);
  }
  if (size === HandoffEventSize.DEFAULT) {
    classes.push(DEFAULT_SIZE_CLASS_NAME);
  }
  if (size === HandoffEventSize.SMALL) {
    classes.push(SMALL_SIZE_CLASS_NAME);
  }

  const onClick = () => onSelect?.();

  return (
    <div className={classes.join(' ')} onClick={onClick}>
      <div className={ICON_CONTAINER_CLASS_NAME}>
        <IbIcon iconName="people-right" size={iconSizeMap[size]} />
      </div>
      <IbTypography.Paragraph type={paragraphTypeMap[size]}>
        {t('Agent: Handoff event: Title', { agentName: handoffData.agent.name })}
      </IbTypography.Paragraph>
      <IbIcon className={STATUS_CLASS_NAME} iconName="check-one" size={iconSizeMap[size]} />
    </div>
  );
};

export default HandoffEvent;
